import { Resolver, gql } from '@apollo/client';

import HttpStatus from 'http-status-codes';

import * as helpers from './helpers';

interface Args {
    filename: string;
    dashboard: ProIngestionDashboard;
}

export const handleProIngestion: Resolver = (
    obj: Record<string, unknown>,
    args: Args,
    { cache },
): ProIngestionDashboard => {
    const { filename, dashboard } = args;

    return helpers.handleProIngestion(
        HttpStatus.OK,
        dashboard,
        filename,
        cache,
    );
};

export const HANDLE_PRO_INGESTION = gql`
    mutation HandleProIngestion(
        $filename: String
        $dashboard: ProIngestionDashboard
    ) {
        handleProIngestion(filename: $filename, dashboard: $dashboard) @client
    }
`;
